import { ExternalLink } from "lucide-react";

export function ExternalUrl({ href, label }: { href: string; label?: string }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={label ? undefined : href}
      className="flex w-full min-w-0 items-center gap-1 text-primary underline-offset-4 hover:underline"
    >
      <span className="min-w-0 truncate">{label || href}</span>
      <ExternalLink className="h-4 w-4 shrink-0" aria-hidden="true" />
    </a>
  );
}
